import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { FaBars, FaTimes } from "react-icons/fa";
import Sidebar from "../CommonComponents/Sidebar";
import LoanRequestsTable from "./LoanRequestsTable";
import LoanRequestForm from "../CommonComponents/LoanRequestForm";
import AccumulativeMerchantRequestContainer from "../AccumulativeRequest/AccumulativeMerchantRequestContainer";
import Pagination from "../Incoming/IncomingComponents/Pagination";
import Tabs from "../CommonComponents/Tabs";
import { RollIdProvider } from "../CommonComponents/RollIdContext";
import RollIdPrompt from "../CommonComponents/RollIdPrompt";

const LoanRequests = () => {
  const { userType } = useParams();
  const navigate = useNavigate();
  const [isSidebarOpen, setSidebarOpen] = useState(false);
  const [showLoanForm, setShowLoanForm] = useState(false);
  const [reload, setReload] = useState(0);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [activeRequest, setActiveRequest] = useState(null);

  const toggleSidebar = () => {
    setSidebarOpen(!isSidebarOpen);
  };

  useEffect(() => {
    let userTypeStorage = localStorage.getItem("user_Type");
    if (!userType || (userType !== "hgo" && userType !== "monazam")) {
      navigate("/");
    } else if (userType.toLowerCase() !== userTypeStorage.toLowerCase()) {
      navigate("/error_page");
    }
  }, [userType]);

  const handleNewLoanRequest = () => {
    setShowLoanForm(true);
  };

  const handleCloseLoanForm = (action) => {
    setShowLoanForm(false);
    if (action === "create") {
      setReload(reload + 1);
    }
  };

  const handleRequestToggle = (requestType) => {
    setActiveRequest(requestType);
  };

  return (
    <RollIdProvider>
      <div className="dashboard-layout d-flex">
        <Sidebar
          isOpen={isSidebarOpen}
          toggleSidebar={toggleSidebar}
          setReload={setReload}
          reload={reload}
          onRequestToggle={handleRequestToggle}
          activeRequest={activeRequest}
        />
        <div className={`main-content ${isSidebarOpen ? "blurred" : ""}`}>
          <div className="d-md-none d-flex sidebar-logo-bg py-3 px-1">
            <button className="btn" onClick={toggleSidebar}>
              {isSidebarOpen ? <FaTimes size={24} /> : <FaBars size={24} />}
            </button>
            <img
              src="/assets/logo.png"
              alt="Logo"
              className="img-fluid logo pe-5"
            />
          </div>

          <RollIdPrompt />
          <div className="me-3 mt-3">
            <Tabs />
          </div>

          <div className="maincontent-container">
            {activeRequest === "accumulative-merchant" ? (
              <AccumulativeMerchantRequestContainer />
            ) : (
            <div className="container-fluid p-4">
              <div className="d-flex justify-content-between align-items-center mb-4">
                <h2 className="hgo-text">Loan Requests</h2>
                {userType !== "monazam" && (
                  <button
                    className="btn btn-success"
                    onClick={handleNewLoanRequest}
                  >
                    New Loan Request
                  </button>
                )}
              </div>

              <div className="table-wrapper">
                <LoanRequestsTable
                  reload={reload}
                    setReload={setReload}
                  page={page}
                  setPage={setPage}
                  setTotalPages={setTotalPages}
                />
              </div>

              {totalPages > 1 && (
                <div className="pagination-container mt-3">
                  <Pagination
                    currentPage={page}
                    totalPages={totalPages}
                    onPageChange={setPage}
                  />
                </div>
              )}
            </div>
            )}
          </div>

          <LoanRequestForm
            isOpen={showLoanForm}
            onClose={handleCloseLoanForm}
          />
        </div>
      </div>
    </RollIdProvider>
  );
};

export default LoanRequests;
